module.exports = __webpack_public_path__ + "media/images/icon/icon_morning-b043240ead81a6a53539d09a1baf1342.png";